export const getErrorAttributes = error => {
  let message = 'Unknown Error'
  let type = 'Unknown Type'
  let status = 500

  if (error.response?.data) {
    const responseData = error.response.data
    if (responseData?.message) {
      message = responseData.message
    } else if (
      typeof responseData.errors?.detail === 'string' &&
      responseData.errors.detail
    ) {
      message = responseData.errors.detail
    } else if (typeof responseData.error === 'string') {
      message = responseData.error
    } else if (
      responseData.error &&
      responseData.error.details &&
      responseData.error.details.length > 0
    ) {
      const messages = responseData.error.details.map(detail => detail.message)
      const types = responseData.error.details.map(detail => detail.type)
      message = messages.join(', ')
      type = types.join(', ')
    }
  }

  if (error.response?.status) {
    status = error.response.status
  }

  return { message, type, status }
}
